module.exports = __webpack_public_path__ + "static/media/Home_Button@3x.65e8ba04.png";